import React, { createContext, useState, useContext, useEffect } from "react";
import { market } from "../CommonPage/MarketFlow/TradeData";
import { comment } from "stylis";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Initialize language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    return savedLanguage || "en";
  });

  // Save language to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("selectedLanguage", language);
  }, [language]);

  const translations = {
    en: {
      bannerTitle: "Born for",
      bannerTitle2: "Traders.",
      bannerSubtitle: "Built to perform.",
      bannerDescription: "Licensed, liquid, and built for speed — everything",
      bannerDescription2: "serious traders need.",
      openAccountButton: "Open Trading Account",
      trading: "Trading",
      promotions: "Promotions",
      Partnership: "Partnership",
      company: "Company",
      accountType: "Account Types",
      signUp: "Sign Up",
      SiggnUP: "Get Started",
      Accounts: "Accounts",
      Metalsbotom: " Ready to Trade Metals With",
      Metalsbotom1:
        "Start trading some of the most valuable assets on the planet with a",
      Metalsbotom2: "global broker. Open an account in seconds.",
      market: "Market",
      companyInfo: "Company",
      Platforms: "Platforms",
      ourOffering: "Our Offerings",
      Easy: "Easy Access to 1,400+ Global Assets",
      login: "Login",
      forexTrade: "Forex Trade",
      stockDerivatives: "Stock Derivatives",
      commodities: "Commodities",
      crypto: "Crypto",
      Indices: "Indices",
      Energies: "Energies",
      Stocks: "Stocks",
      preciousMetals: "Precious Metals",
      shares: "Shares",
      cryptoCurrencies: "Crypto Currencies",
      equityIndices: "Equity Indices",
      energies: "Energies",
      Referrals: "Referrals",
      AllReff: "Referrals (Coming Soon)",
      ReComing: "(Coming Soon)",
      bbcropCopyTrading: "BBCorp Copy trading",
      bbcropCompetitions: "BBCorp Competitions",
      executionPolicy: "Execution Policy",
      marginLeverage: "Margin & Leverage",
      mt5Platforms: "MT5 Platforms",
      partnerWithUs: "Partner with us",
      whoIsBBCorp: "KYC & AML",
      FoterSupport: "Support",
      careers: "Careers",
      regulation: "Regulation",
      legalDocuments: "Legal Documents",
      bbcropAwards: "BBCorp Awards",
      contactUs: "Contact Us",
      helpCenter: "Help Center",
      partnership: "Partnership",
      easyAccessTo: "Easy Access to",
      global: "Global",
      assets: "Assets",
      tradingNew: {
        titleLine1: "Discover Forex",
        titleLine2: "Trading",
        active: "Forex Trading",
        tradingBTN: "Open Trading Account",
        subtitle:
          "Buy and sell in the most liquid global markets, like EURUSD, 5 days a week with market-leading execution and trading conditions.",
      },
      tradingNew1: {
        titleLine1: "Discover Stocks",
        active: "Stock Derivatives",
        titleLine2: "Derivatives Trading",
        subtitle:
          "Trade your favorite brands from Netflix to Apple as stock derivatives with competitive conditions and pricing.",
      },
      commoditiesTrading: {
        titleLine1: "Discover",
        active: "Commodities",
        titleLine2: "Commodities",
        subtitle:
          "Trade soft Commodities like coffee and sugar with excellent conditions.",
      },

      metalsTrading: {
        titleLine1: "Discover Metals",
        active: "Precious Metals",
        titleLine2: "Trading",
        subtitle:
          "Trade soft Commodities like coffee and sugar with excellent conditions.",
      },
      sharesTrading: {
        titleLine1: "Discover",
        active: "Shares",
        titleLine2: "Shares",
        subtitle:
          "Trade real stocks of global companies including Apple, Disney, and Microsoft from your BBCorp account.",
      },
      cryptoTrading: {
        titleLine1: "Discover Crypto",
        titleLine2: "Derivatives Trading",
        active: "Cryptocurrencies",
        subtitle:
          "Trade Crypto derivatives including Bitcoin at real-time prices with unparalleled conditions.",
      },
      equityIndicesTrading: {
        titleLine1: "Discover Equity",
        titleLine2: "Indices",
        active: "Equity Indices",
        subtitle:
          "Trade combinations of world-renowned shares with our elite selection of equity indices.",
      },
      energiesTrading: {
        titleLine1: "Discover Energies",
        titleLine2: "Trading",
        active: "Energies",
        subtitle:
          "Trade oil and gas variants with low costs and competitive conditions.",
      },
      optionsTab: {
        name: "Forex Trading",
        name1: "Cryptocurrencies",
        name2: "Stock Derivatives",
        name3: "Commodities",
        name4: "Equity Indices",
        name5: "Precious Metals",
        name6: "Energies",
        name7: "Shares",
      },
      whyTrade: "Why Trade forex with BBCorp?",
      whyTradeindices: "Why trade equity indices with BBCorp?",
      Tradesf:
        "Trade the world’s first currencies and most precious assets on the planet",
      ClainT:
        "Claim your piece of the world's most successful companies and expand your potential.",
      EnergiesD:
        "Take advantage of the most liquid energies that are renowned for their trading potential.",
      trafeEWn: "Why Trade Energies With BBCorp?",
      trafeEWn1: "Why Trade Energies With",
      whyTradeSub:
        "Enter the world’s most liquid market with the confidence of having a leading broker at your side.",
      cardsDataeEn: {
        title1: "Trade 24/5",
        description1:
          "Explore the global currency markets with<br/> uninterrupted trading opportunities.",

        title2: "Stay Connected",
        description2:
          "Trade with full flexibility from Whatsapp to the BBCorp MetaTrader 5 app.",

        title3: "Magnify Your Trades",
        description3:
          "Boost the potential of your trades with<br/> leverage for traders of all levels.",

        title4: "Forget Charges",
        description4:
          "Use your money to trade, not to pay for services.<br/> You can enjoy no hidden fees or extra charges.",
      },
      indicesCardData: {
        title: "Trade Multiple Brands",
        description:
          "You can trade groups of global brands in one asset, maximizing your diversification.",
        title1: "Buy and Sell Indices",
        description1:
          "Trade both rising and falling markets with equity indices, taking advantage of all conditions.",
        title2: "Portfolio Diversification",
        description2:
          "Reduce potential risk and gain exposure to a wider range of opportunities.",
        title3: "Forget Charges",
        description3:
          "Use your money to trade, not to pay for services, with no hidden fees or extra charges.",
      },
      energiesCardData: {
        title: "Trade Top Energies",
        description:
          "You can trade groups of global brands in one asset, maximizing your diversification.",
        title1: "Cut Your Costs",
        description1:
          "Trade both rising and falling markets with equity indices, taking advantage of all conditions.",
        title2: "Magnify Your Trades",
        description2:
          "Reduce potential risk and gain exposure to a wider range of opportunities.",
        title3: "Forget Charges",
        description3:
          "Use your money to trade, not to pay for services, with no hidden fees or extra charges.",
      },

      alternativeAssetsCardData: {
        title: "Diversify Your Portfolio",
        description:
          "Trade alternative assets that tend to thrive in different market conditions.",
        title1: "Trade Without Owning",
        description1:
          "Speculate on price movements without the hassle and cost of owning the assets.",
        title2: "Magnify Your Trades",
        description2:
          "Boost the potential of your trades with leverage for traders of all levels.",
        title3: "Enjoy No Extra Fees",
        description3:
          "Focus on trading with no extra commission or hidden fees.",
      },

      cardsDataCommom: {
        title: "Diversify Your Portfolio",
        description:
          "Diversify your portfolio with assets affected by different fundamentals and trends.",
        title1: "Go Long and Shorts",
        description1: "Capitalise on all price movements including downtrends.",
        title2: "Trade Without Owning",
        description2:
          "Trade the assets without worrying about physically owning them.",
        title3: "Lower Your Costs",
        description3:
          "Trade without the high stock exchange cost or any hidden fees.",
      },
      cardDataEncosts: {
        title1: "Cut your costs",
        description1:
          "Skip stock exchange costs and trade straight from your BBCorp account",

        title2: "Buy and sell stocks",
        description2:
          "Buy and sell assets to take advantage of all market conditions.",

        title3: "Pay 0 commissions",
        description3:
          "Lower your costs and increase your potential with 0 commissions",

        title4: "Trade fractional shares",
        description4:
          "Use your money to trade, not to pay for services. You can enjoy no hidden fees or extra charges.",
      },

      cardDataObj: {
        // English
        title1: "Trade Global Shares",
        description1:
          "Trade the world with access to Shares from the USA, Europe and the UK.",

        title2: "Access 100s of Options",
        description2:
          "Diversify with brands in tech, fashion, travel, sports, and more.",

        title3: "Lower Your Costs",
        description3: "Choose cost-effective trading with no hidden fees.",

        title4: "Pick Your Brands",
        description4:
          "Turn brands you believe in, into an investment opportunity.",
      },

      ourInvestors: {
        title: "Discover Our Investor's",
        favorites: "Favorites",
        subtitle:
          "Recognized by the industry. Rewarding our partners. Built to grow with you.",
        metaTrader: {
          title: "MetaTrader 5",
          description:
            "Get full access to BBCorp services with the top-rated, award-winning MT5 App.",
          getItOn: "GET IT ON THE",
          playStore: "Play Store",
          downloadOn: "Download on the",
          appStore: "App Store",
          openAccount: "Open an account",
        },
      },
      whatsAppTrading: {
        title: "WhatsApp Trading?",
        subtitle:
          "Open your account under 2 minutes on our BBCorp WhatsApp portal",
        openWhatsApp: "Open WhatsApp Portal",
        title1: "Tens of Deposit Methods",
        description1:
          "Seamlessly add funds through a wide range of deposit options tailored to your needs — from local bank transfers and credit cards to global stablecoins and cash agents. Whether you’re on the move or managing from home, funding your account has never been easier or more flexible.",
        title2: "Advanced Infrastructure & Automation",
        description2:
          "Our AI-driven infrastructure oversees every stage—from onboarding and deposit processing to real-time transactions, behavioral monitoring, risk management, and seamless withdrawals.",
      },
      Discover: {
        title: "Built for growth",
        subtitle: "Discover our markets",
        description:
          "We serve institutional and individual clients executing trades",
        description1:
          "worldwide — delivering precision, speed, and reliability anytime",
        description2: "anywhere.",
      },
      Bonus: {
        title: "50% Bonus",
        favorites: "Get a 50% Bonus up to $500",
        subtitle:
          "Use out funds to trade more, reduce your risk, and boost your returns.",
        openAccount: "Claim Your Bonus",
      },
      Competitions: {
        title: "BBCorp Competitions",
        subtitle: "Trade your way to the top and win your share of",
        subtitle1: "$100,000+ in withdrawable cash prizes.",
        openAccount: "Coming Soon",
      },
      deposit: {
        title: "300+ deposit methods",
        subtitle: "From bank transfers to crypto to even",
        subtitle1: "local cash providers, we do it in more than",
        subtitle2: "180+ countries",
        openAccount: "View Deposit Method",
      },
      acountSection: {
        title: "Open and Grow Today",
        subtitle:
          "Open an account today and access an opportunity to grow your wealth in a secure, and trustable institution.",
        btnTitle: "Open an account now",
        cardsTitle: {
          title: "Standard Account",
          title1: "Trader Account",
          title2: "Investor Account",
          sub: "Account",
          subtitle:
            "Open our most popular account which has no commission while trading",
          subtitle1:
            "Perfect for high-volume trading with low spreads, reduced swaps, and commissions.",
          subtitle2:
            "Want to invest in stocks? Open a shares account to access market opportunities.",
          btnTitle: "Minimum Deposit $10",
          btnTitle1: "Minimum Deposit $10",
          btnTitle2: "Minimum Deposit $30,000",
          bltile: "Get Started",
          Markets: "Markets",
          marketSub:
            "Forex, Precious Metals, Equity Indices, Cryptocurrencies, Thematic Indices, Stocks,Turbo Stocks, Commodities, Energies",
          marketT1: "Bonus Eligibility*",
          marketT2: "Micro Account Options",
          marketT3: "100:1",
          marketT4: "Maximum Leverage",
          marketT5: "20%",
          marketT6: "Stop Out Level",
          marketT7: "Swap Free",
          marketT8: "Commission",
          marketT9: "Minimum Deposit",
          marketT10: "$10",
          marketT11: "Spreads as low as",
          show: "Show more",
          less: "Less more",
          firsy:
            "All accounts offer negative balance protection, hedging and Islamic options as standard. If the currency you deposit",
          firsy1:
            "into your account is not USD, the amount shown is the equivalent in the deposit currency.",
          spreads: [
            {
              pair: "GOLD",
              value: "2.7",
            },
            {
              pair: "USD/JPY",
              value: "2",
            },
            {
              pair: "USD/JPY",
              value: "1.6",
            },
          ],
          tier: "*Some countries might be excluded",
        },
      },
      PickData: "Pick Your Pairs",
      PickDatayour: "Pick your energies",
      commonit: "Ready to Trade Commodities",
      commonit1: "With BBCorp?",
      commonitEqu1:
        "Start exploring some of the most popular indices with a leading",
      commonitEqu2: "broker. Open an account within seconds.",
      commonitEqu: "Ready to trade equity indices",
      comment2:
        "Start trading popular Commodities with an industry-leading broker.",
      comment3: "Open an account within seconds.",
      PickDatayourDes: "You can see all trading hours in the Members Area.",
      bttomTxt:
        " Explore beyond the top 10 Stock derivatives! Ready to discover more?",
      RegisBTN: "Register to see more",
      IndicesTitle: "Indices",
      IndicesTitleFuture: "Future Indices",
      moreInfo: " *More info",
      IndicesTitleFutureCash: "Cash Energies",
      RegisBTNindices: "Pick your equity indices",
      RegisBTNiTitle: "You can see all trading hours in the Members Area.",
      CommoditiesTile: "Pick Your Commodities",
      CommoditiesTileDes: "You can see all trading hours in the Members Area.",
      metalsTitle: "Pick your precious metals",
      metalsTitleDes: "You can see all trading hours in the members area.",
      shareTitle: "Pick Your Share",
      Entitle:
        "Experience trading global energies with a leading broker that always",
      Entitle1: "has your back. Open an account within seconds.",
      shareTitleDes:
        "You can see all trading hours and stay updated on corporate events in the Members Area.",
      tab1: "Standard",
      tab2: "Ultra Low Standard",
      tab3: "Futures",
      derivate: "Pick Your Stock Derivatives",
      desDerivate:
        "You can see all trading hours and stay updated on corporate events in the Members Area.",
      tableData: {
        Symbol: "Symbol",
        AverageSpread: "Average Spread (pips)",
        Spread: "Spread as low as (pips)",
        MaxLeverage: "Max Leverage",
        Action: "Action",
      },

      picDec: "The Forex market operates Monday – Friday 00:05 – 23:50 GMT+2",
      footerAccounts: "Accounts",
      footerMarket: "Market",
      footerOffering: "Our Offering",
      footerPlatform: "Platforms",
      footerSupport: "Support",
      footerAccount: "Account Types",
      footerForex: "Forex Trade",
      footerStock: "Stock Derivatives",
      blueBTN: "Start Trading Now",
      footerCommaondities: "Commodities",
      footerPrecious: "Precious Metals",
      footerShares: "Shares",
      cryptoTitle: "Pick Your Cryptocurrencies",
      cryptoTitleDes: "The Crypto market operates 24/7.",
      footerCrypto: "Crypto Currencies",
      footerEquity: "Equity Indices",
      footerEnergies: "Energies",
      footerTrading: "BBCorp Copy trading",
      footerCompetitions: "BBCorp Competitions",
      footerPolicy: "Execution Policy",
      footerLeverage: "Margin & Leverage",
      footerMt5: "MT5 Platforms",
      footerHelp: "Help and Support",
      footerContact: "Contact Us",
      footerPolicy: "Privacy policy",
      footerTerm: "BBCorp Terms",
      footerButtontitle: "GET IT ON",
      footerButtonName: "Google Play",
      footerButton2title: " Download on the",
      footerButton2Name: "App Store",
      footerPayment: "Payment Accepted",
      footerLegal: "Legal Documentation",
      footerCopy: "Copyright",
      footerRight: "BBCrop LTD. All rights reserved",
      footerDescription:
        "CFD’s are complex instruments and come with a high risk of losing money rapidly due to leverage. 77% of retail investor accounts lose money when trading CFD’s with this provider. You should consider whether you understand how CFD’s work and whether you can afford to take the high risk of losing your money. We recommend you seek professional advice before investing. BBcorp LTD (Comoros) Limited is a company incorporated with limited liability under the laws of the C O M O R O S U N I O N, under registration number HV00724047, with its registered address at Bonovo Road – Fomboni -Island of Mohéli – Comoros Union. BBCorp LTD (Comoros) Limited is authorized Mwali International Services Authority as an International Brokerage and Clearing House License number BFX2024241. And at its physical office in Cyprus at Taki Sofokleous 23A -2049, Strovolos, Nicosia. We provide an execution-only service. We do not provide investment advice or management services. Any analysis, opinion, commentary, or research-based material on our website is for information and educational purposes only and is not, under any circumstances, intended to be an offer, recommendation, advice, or solicitation to buy or sell. We are pleased to receive account applications from a wide range of countries. However, while we cannot currently accept applications from certain countries, we encourage you to apply if you meet our eligibility criteria, and we appreciate your interest in our services. Deposits and withdrawals may be coordinated, facilitated, or processed by one or more of the affiliates of BBCorp LTD, including BBcorp LB.",
      weathTitle: " Begin your wealth",
      weathTitles: " journey with us",
      joinTitle:"Join Us",
      joinDes:"We pioneered the strict no requotes, no rejections policy that established our reputation. To prevent slippage and keep your strategy aligned with real-time market prices, 99% of all trades are executed in less than one second.",
      weathSetUp: "Instant Setup",
      weathSupport: "24/7 Support",
      weathLiquidity: "Deep Liquidity",
      weathButton: "Contact Sales",
      sliderTitle: "International Licenses. Local Trust.",
      sliderDescription:"At BBCorp, compliance isn’t a formality—it’s a foundation. We operate under a growing framework of international regulatory standards that ensures every aspect of our business is secure, transparent, and built to scale globally. As we expand our footprint across new markets, we remain committed to maintaining the highest levels of trust, governance, and operational integrity.",
      sliderCard1: "Best Broker",
      sliderCard2: "Middle East",
      shareCom: "Why Trade Shares",
      shareCom1: "With BBCorp?",
      shareComDes: "Claim your piece of the world's most successful companies",
      shareComDes1: "and expand your potential.",
      sliderCard3: "Most Trusted",
      sliderCard4: "Asia",
      sliderCard5: "Top Broker",
      sliderCard6: "Africa",
      sliderCard7: "Fastest Growing",
      sliderCard8: "Global",
      globeHead: "Internationally Recognized",
      globeTitle: " Executing on the global stage",
      globeDesc:
        "We serve institutional and individual clients executing trades worldwide — delivering  precision, speed, and reliability, anytime, anywhere.",
      globeNumber: "10,000+",
      globeNumbers: "1000+",
      globeNumber2: "Happy Clients",
      globeNumber3: "2005",
      globeNumber4: "Est.",
      globeNumber5: "Transactions",
      globeNumber6: "3",
      newWealthTitle: "Not ready for the",
      newWealthTitle2: "real deal?",
      globeNumber7: "Regulated Licenses",
      globeButton: "  Start Trading Safely",
      investTitle: "From young investors to institutional market movers.",
      investTitles: "We offer services to all sorts of accounts.",
      stripeCardTitle: "Forex",
      stripeCardDes:
        "Trade the world’s largest financial market with ultra-tight spreads and instant execution. Major, minor, and exotic currencies — around the clock, 5 days a week, no downtime.",
      tradingStripe: "Start Trading",
      stripeCoomDes:
        "From gold to coffee — access physical markets through digital contracts. Hedge inflation or trade momentum.",
      srtripeThirdDes:
        "Digital volatility, real opportunity. Trade top cryptocurrencies with leverage and precision in a secure environment.",
      stripeFourDesc:
        "Track and trade entire markets — S&P, DAX, NASDAQ and more — all from one account, in real time.",
      stripeFifth:
        "Oil, gas, and global demand in motion. Trade energy markets with responsive pricing and clear margins.",
      stripeSixth:
        "Build Your Wealth with the World's Most Powerful Companies — Everywhere.",
      newWealthDes:
        "Start testing in a demo environment before starting with your real account",
      newWealthDes2:
        "Whenever your ready for your wealth journey, we are ready for you.",
      legalTitle: "Legal Documents",

      legalTitleDes:
        "It’s important that you read and understand any documentation relating to the services you’re interested in. Anything that applies to your account will be clearly marked during the registration process. You should familiarise yourself with these ",
      legalTitleDes1: "documents before completing your registration. ",
      legalButton: "Open an account now",
      lagalSemiTitle1: "BBCorp Corporate Limited",
      lagalSemiTitle2: "BBCorp (SC) Limited",
      legalSemiTitle3: "BBCorp International MU Ltd",
      legalMainHead: "Business Terms and Policies (in English)",
      leagcard1: "Terms and Conditions",
      leagcard2: "VPS Terms and Condition",
      leagcard3: "Money Laundering prevention",
      leagcard4: "Order execution policy",
      leagcard5: "Risk Discloser for financial instruments",
      leagcard6: "Conflict of interest policy",
      leagcard7: "Complaint handling procedure",
    },

    ar: {
      bannerTitle: "وُلد من أجل",
      bannerTitle2: "المتداولون.",
      bannerSubtitle: "مبني للأداء.",
      bannerDescription: "مرخص، سائل، ومبني للسرعة — ما يحتاجه التجار الجادون.",
      openAccountButton: "فتح حساب تداول",
      trading: "تداول",
      promotions: "العروض الترويجية",
      company: "الشركة",
      Metalsbotom: "هل أنت مستعد لتداول المعادن؟",
      Metalsbotom1: "ابدأ تداول بعض من أثمن الأصول على وجه الأرض مع",
      Metalsbotom2: "وسيط عالمي. افتح حسابًا في ثوانٍ.",
      accountType: "أنواع الحسابات",
      signUp: "إنشاء حساب",
      Accounts: "الحسابات",
      market: "السوق",
      Platforms: "المنصات",
      ourOffering: "عروضنا",
      crypto: "العملات الرقمية",
      Easy: "وصول سهل إلى أكثر من ١٤٠٠+ أصل من الأصول العالمية",
      login: "تسجيل الدخول",
      Energies: "الطاقات",
      commonit: "هل أنت مستعد لتداول السلع",
      commonit1: "مع BBCorp؟",
      commonitEqu: "هل أنت مستعد لتداول مؤشرات الأسهم؟",
      comment2: "ابدأ تداول السلع الشائعة مع وسيط رائد في الصناعة.",
      comment3: "افتح حسابًا في غضون ثوانٍ.",
      Stocks: "الأسهم",
      Indices: "المؤشرات",
      forexTrade: "تداول العملات الأجنبية",
      stockDerivatives: "مشتقات الأسهم",
      commodities: "السلع",
      preciousMetals: "المعادن الثمينة",
      shares: "الأسهم",
      cryptoCurrencies: "العملات المشفرة",
      equityIndices: "مؤشرات الأسهم",
      energies: "الطاقة",
      Referrals: "الإحالات",
      bbcropCopyTrading: "نسخ التداول BBCorp",
      bbcropCompetitions: "مسابقات BBCorp",
      executionPolicy: "سياسة التنفيذ",
      marginLeverage: "الهامش والرافعة المالية",
      mt5Platforms: "منصات MT5",
      partnerWithUs: "كن شريكاً معنا",
      whoIsBBCorp: "من هي مجموعة BBCorp؟",
      careers: "وظائف",
      regulation: "التنظيم",
      legalDocuments: "المستندات القانونية",
      bbcropAwards: "جوائز BBCorp",
      contactUs: "اتصل بنا",
      helpCenter: "مركز المساعدة",
      partnership: "شراكة",
      easyAccessTo: "وصول سهل إلى",
      companyInfo: "معلومات الشركة",
      global: "العالمية",
      assets: "الأصول",
      tradingNew: {
        titleLine1: "اكتشف الفوركس",
        titleLine2: "تداول",
        active: "تداول الفوركس",
        tradingBTN: "افتح حساب تداول",
        subtitle:
          "اشترِ وبِع في أكثر الأسواق العالمية سيولة، مثل EURUSD، على مدار 5 أيام في الأسبوع مع تنفيذ وظروف تداول رائدة في السوق.",
      },
      tradingNew1: {
        titleLine1: "اكتشف الأسهم",
        active: "مشتقات الأسهم",
        titleLine2: "تداول المشتقات",
        subtitle:
          "تداول علامتك التجارية المفضلة من نتفليكس إلى آبل كمشتقات أسهم بشروط وأسعار تنافسية",
      },
      commoditiesTrading: {
        titleLine1: "اكتشف",
        active: "السلع",
        titleLine2: "السلع",
        subtitle: "تداول السلع الخفيفة مثل القهوة والسكر بشروط ممتازة.",
      },
      metalsTrading: {
        titleLine1: "اكتشف المعادن",
        active: "المعادن الثمينة",
        titleLine2: "تداول",
        subtitle: "تداول السلع الخفيفة مثل القهوة والسكر بشروط ممتازة.",
      },
      sharesTrading: {
        titleLine1: "اكتشف",
        active: "الأسهم",
        titleLine2: "الأسهم",
        subtitle:
          "تداول الأسهم الحقيقية للشركات العالمية مثل آبل، ديزني، ومايكروسوفت من خلال حساب BBCorp الخاص بك.",
      },
      cryptoTrading: {
        titleLine1: "اكتشف العملات الرقمية",
        titleLine2: "تداول المشتقات",
        active: "العملات الرقمية",
        subtitle:
          "تداول مشتقات العملات الرقمية بما في ذلك البيتكوين بأسعار لحظية وبشروط لا مثيل لها.",
      },
      equityIndicesTrading: {
        titleLine1: "اكتشف الأسهم",
        titleLine2: "المؤشرات",
        active: "مؤشرات الأسهم",
        subtitle:
          "تداول مجموعات من الأسهم العالمية الشهيرة من خلال مجموعتنا المتميزة من مؤشرات الأسهم.",
      },
      IndicesTitle: "المؤشرات",
      IndicesTitleFuture: "مؤشرات العقود الآجلة",
      moreInfo: "*مزيد من المعلومات",
      IndicesTitleFutureCash: "الطاقات النقدية",
      energiesTrading: {
        titleLine1: "اكتشف الطاقة",
        titleLine2: "تداول",
        active: "الطاقات",
        subtitle: "تداول مشتقات النفط والغاز بتكاليف منخفضة وشروط تنافسية.",
      },
      optionsTab: {
        name: "تداول الفوركس",
        name1: "العملات الرقمية",
        name2: "مشتقات الأسهم",
        name3: "السلع",
        name4: "مؤشرات الأسهم",
        name5: "المعادن الثمينة",
        name6: "الطاقات",
        name7: "الأسهم",
      },
      whyTrade: "لماذا تتداول الفوركس مع BBCorp؟",
      whyTradeindices: "لماذا تتداول مؤشرات الأسهم مع BBCorp؟",
      whyTradeSub:
        "ادخل إلى أكثر الأسواق سيولة في العالم بثقة وجود وسيط رائد إلى جانبك.",
      Tradesf: "تداول أولى العملات في العالم وأكثر الأصول قيمة على هذا الكوكب.",
      ClainT: "احصل على حصتك من أنجح الشركات في العالم ووسّع من إمكانياتك.",
      EnergiesD:
        "استفد من أكثر مصادر الطاقة سيولة والمعروفة بإمكاناتها الكبيرة في التداول.",
      trafeEWn: "لماذا تتداول الطاقة مع BBCorp؟",
      trafeEWn1: "لماذا تتداول الطاقة مع",
      cardsDataeEn: {
        title1: "تداول 24/5",
        description1:
          "استكشف أسواق العملات العالمية مع فرص تداول مستمرة دون انقطاع.",

        title2: "ابقَ على اتصال",
        description2:
          "تداول بكل مرونة عبر العديد من المنصات، بما في ذلك تطبيق XM.",

        title3: "قم بتضخيم تداولاتك",
        description3:
          "عزز إمكانات تداولاتك بالرافعة المالية لجميع مستويات المتداولين.",

        title4: "انسى الرسوم",
        description4:
          "استخدم أموالك للتداول، وليس لدفع رسوم الخدمات. استمتع بعدم وجود رسوم خفية أو إضافية.",
      },
      energiesCardData: {
        title: "تداول أبرز مصادر الطاقة",
        description:
          "يمكنك تداول مجموعات من العلامات التجارية العالمية في أصل واحد، لتعظيم تنويعك الاستثماري.",
        title1: "قلّل من تكاليفك",
        description1:
          "تداول في الأسواق الصاعدة والهابطة مع مؤشرات الأسهم، واستفد من جميع ظروف السوق.",
        title2: "عزّز تداولاتك",
        description2:
          "قلّل من المخاطر المحتملة واحصل على فرصة للتعرض لعدد أكبر من الفرص.",
        title3: "انسَ الرسوم",
        description3:
          "استخدم أموالك للتداول، وليس لدفع رسوم الخدمات، دون أي رسوم خفية أو إضافية.",
      },
      cardDataEncosts: {
        title1: "قلل من تكاليفك",
        description1:
          "تجاوز تكاليف البورصة وتداول مباشرة من حساب BBCorp الخاص بك",

        title2: "اشترِ وبِع الأسهم",
        description2: "اشترِ وبِع الأصول للاستفادة من جميع ظروف السوق.",

        title3: "ادفع 0 عمولات",
        description3: "قلل من تكاليفك وزد من إمكانياتك بدون أي عمولات",

        title4: "تداول الأسهم الجزئية",
        description4:
          "استخدم أموالك للتداول وليس لدفع رسوم. استمتع بعدم وجود رسوم خفية أو تكاليف إضافية.",
      },
      indicesCardData: {
        title: "تداول عدة علامات تجارية",
        description:
          "يمكنك تداول مجموعات من العلامات التجارية العالمية في أصل واحد، مما يزيد من تنويع محفظتك.",
        title1: "شراء وبيع المؤشرات",
        description1:
          "تداول الأسواق الصاعدة والهابطة مع مؤشرات الأسهم، واستفد من جميع الظروف.",
        title2: "تنويع المحفظة",
        description2:
          "قلل من المخاطر المحتملة واحصل على فرص متنوعة في الأسواق.",
        title3: "تخلص من الرسوم",
        description3:
          "استخدم أموالك في التداول، وليس في دفع الرسوم، بدون أي رسوم خفية أو تكاليف إضافية.",
      },
      alternativeAssetsCardData: {
        title: "نوّع محفظتك",
        description: "تداول الأصول البديلة التي تزدهر في ظروف السوق المختلفة.",
        title1: "تداول بدون امتلاك",
        description1:
          "قم بالمضاربة على تحركات الأسعار دون عناء وتكلفة امتلاك الأصول.",
        title2: "قم بتكبير تداولاتك",
        description2:
          "عزّز إمكانيات تداولاتك باستخدام الرافعة المالية لجميع مستويات المتداولين.",
        title3: "استمتع بعدم وجود رسوم إضافية",
        description3: "ركّز على التداول بدون عمولات إضافية أو رسوم خفية.",
      },

      cardsDataCommom: {
        title: "نوّع محفظتك الاستثمارية",
        description: "نوّع محفظتك باستخدام أصول تتأثر بعوامل وأساسيات مختلفة.",
        title1: "صفقات شراء وبيع",
        description1:
          "استفد من جميع تحركات الأسعار بما في ذلك الاتجاهات الهابطة.",
        title2: "تداول بدون امتلاك فعلي",
        description2: "تداول الأصول دون القلق بشأن امتلاكها فعليًا.",
        title3: "قلل تكاليفك",
        description3: "تداول دون تكاليف بورصة مرتفعة أو رسوم خفية.",
      },

      cardDataObj: {
        title1: "تداول الأسهم العالمية",
        description1:
          "تداول في جميع أنحاء العالم مع إمكانية الوصول إلى الأسهم من الولايات المتحدة وأوروبا والمملكة المتحدة.",

        title2: "الوصول إلى المئات من الخيارات",
        description2:
          "نوّع استثماراتك مع علامات تجارية في التكنولوجيا والموضة والسفر والرياضة والمزيد.",

        title3: "قلّل من تكاليفك",
        description3: "اختر التداول بتكاليف منخفضة وبدون رسوم خفية.",

        title4: "اختر علامتك التجارية",
        description4:
          "حوّل العلامات التجارية التي تؤمن بها إلى فرصة استثمارية.",
      },

      acountSection: {
        title: "ابدأ وحقق النمو اليوم",
        subtitle:
          "افتح حسابًا اليوم واستفد من فرصة لتنمية ثروتك في مؤسسة آمنة وجديرة بالثقة.",
        btnTitle: "افتح حسابًا الآن",
        cardsTitle: {
          title: "الحساب القياسي",
          title1: "حساب المتداول",
          title2: "حساب المستثمر",
          sub: "الحساب",
          subtitle:
            "افتح حسابنا الأكثر شيوعًا والذي لا يحتوي على عمولة أثناء التداول",
          subtitle1:
            "مثالي للتداول بكميات كبيرة مع فروق أسعار منخفضة وتقليل الرسوم والعمولات.",
          subtitle2:
            "هل ترغب في الاستثمار في الأسهم؟ افتح حساب أسهم للوصول إلى فرص السوق.",
          btnTitle: "الحد الأدنى للإيداع 20 دولارًا",
          btnTitle1: "الحد الأدنى للإيداع 500 دولار",
          btnTitle2: "الحد الأدنى للإيداع 30,000 دولار",
          bltile: "ابدأ الآن",
          Markets: "الأسواق",
          show: "عرض المزيد",
          less: " عرض أقل",
          firsy:
            "جميع الحسابات توفر الحماية من الرصيد السلبي، والتحوط، وخيارات إسلامية كمعيار.",
          firsy1:
            "إذا لم تكن العملة التي أودعتها في حسابك هي الدولار الأمريكي، فسيتم عرض المبلغ بما يعادله بعملة الإيداع.",
          marketSub:
            "الفوركس، المعادن الثمينة، مؤشرات الأسهم، العملات الرقمية، المؤشرات الموضوعية، الأسهم، الأسهم التوربينية، السلع، الطاقات",
          marketT1: "أهلية الحصول على المكافأة*",
          marketT2: "خيارات الحساب الميكرو",
          marketT3: "1000:1",
          marketT4: "الرافعة المالية القصوى",
          marketT5: "20%",
          marketT6: "مستوى الإيقاف",
          marketT7: "خالي من الفوائد",
          marketT8: "العمولة",
          marketT9: "الحد الأدنى للإيداع",
          marketT10: "10 دولار",
          marketT11: "فروق أسعار تبدأ من",
          spreads: [
            {
              pair: "GOLD",
              value: "2.7",
            },
            {
              pair: "USD/JPY",
              value: "2",
            },
            {
              pair: "USD/JPY",
              value: "1.6",
            },
          ],
          tier: "*قد يتم استبعاد بعض الدول",
        },
      },
      ourInvestors: {
        title: "اكتشف مفضلات",
        favorites: "مستثمرينا",
        subtitle: "معترف به من قبل الصناعة. مكافأة شركائنا. مصمم للنمو معك.",
        metaTrader: {
          title: "تطبيق ميتا تريدر",
          description:
            "احصل على وصول كامل إلى خدمات BBCorp مع تطبيق MT5 الحائز على جوائز.",
          getItOn: "احصل عليه من",
          playStore: "متجر جوجل بلاي",
          downloadOn: "حمل من",
          appStore: "متجر التطبيقات",
          openAccount: "افتح حساباً",
        },
      },
      Bonus: {
        title: "٪50 بونص",
        favorites: "احصل على بونص بنسبة 50٪ حتى 500 دولار",
        subtitle:
          "استخدم أموالنا للتداول أكثر، وتقليل المخاطر، وزيادة العوائد.",
        openAccount: "احصل على البونص الآن",
      },
      Competitions: {
        title: "مسابقات BBCorp",
        subtitle: "تداول بطريقتك نحو القمة واربح حصتك من",
        subtitle1: "أكثر من 100,000 دولار من الجوائز النقدية القابلة للسحب.",
        openAccount: "قريبًا",
      },

      whatsAppTrading: {
        title: "تداول عبر واتساب؟",
        subtitle: "افتح حسابك في أقل من دقيقتين عبر بوابة BBCorp على واتساب",
        openWhatsApp: "افتح بوابة واتساب",
        title1: "أدوات خدمة ذاتية قوية",
        description1:
          "انضم إلى أكثر من 1,000,000 متداول ينسخون استراتيجيات التداول الرابحة أو شارك تداولاتك واربح عمولات.",
        title2: "إدارة حساب سهلة",
        description2:
          "أدِر تداولاتك، وإيداعاتك، وسحوباتك من خلال واجهة واتساب البديهية لدينا.",
      },
      deposit: {
        title: "أكثر من 300 طريقة إيداع",
        subtitle: "من التحويلات البنكية إلى العملات الرقمية وحتى",
        subtitle1: "مقدمي النقد المحلي، نحن نوفرها في أكثر من",
        subtitle2: "180+ دولة",
        openAccount: "عرض طرق الإيداع",
      },
      bttomTxt:
        "استكشف ما هو أبعد من أفضل 10 مشتقات للأسهم! هل أنت مستعد لاكتشاف المزيد؟",
      shareTitle: "اختر سهمك",
      shareTitleDes:
        "يمكنك مشاهدة جميع ساعات التداول والبقاء على اطلاع بآخر الأحداث الخاصة بالشركات في منطقة الأعضاء.",
      tab1: "قياسي",
      tab2: "قياسي منخفض جدًا",
      tab3: "العقود الآجلة",
      PickData: "اختر أزواجك",
      PickDatayour: "اختر الطاقات الخاصة بك",
      PickDatayourDes: "يمكنك مشاهدة جميع ساعات التداول في منطقة الأعضاء.",
      CommoditiesTile: "اختر السلع الخاصة بك",
      CommoditiesTileDes:
        "يمكنك الاطلاع على جميع ساعات التداول في منطقة الأعضاء.",
      metalsTitle: "اختر المعادن الثمينة الخاصة بك",
      metalsTitleDes: "يمكنك مشاهدة جميع ساعات التداول في منطقة الأعضاء.",
      derivate: "اختر مشتقات الأسهم الخاصة بك",
      RegisBTN: "قم بالتسجيل لعرض المزيد",
      RegisBTNindices: "اختر مؤشرات الأسهم الخاصة بك",
      RegisBTNiTitle: "يمكنك مشاهدة جميع ساعات التداول في منطقة الأعضاء.",
      cryptoTitle: "اختر العملات الرقمية الخاصة بك",
      cryptoTitleDes:
        "سوق العملات الرقمية يعمل على مدار الساعة طوال أيام الأسبوع.",
      desDerivate:
        "يمكنك الاطلاع على جميع ساعات التداول والبقاء على اطلاع بآخر الأحداث الخاصة بالشركات في منطقة الأعضاء.",
      tableData: {
        Symbol: "الرمز",
        AverageSpread: "متوسط الفارق (نقطة)",
        Spread: "الفارق يبدأ من (نقطة)",
        MaxLeverage: "أقصى رافعة مالية",
        Action: "الإجراء",
      },
      picDec:
        "سوق الفوركس يعمل من الاثنين إلى الجمعة من الساعة 00:05 حتى 23:50 بتوقيت GMT+2",
      footerAccounts: "الحساب",
      footerMarket: "السوق",
      footerOffering: "عرضنا",
      Entitle: "اختبر تداول الطاقات العالمية مع وسيط رائد يساندك دائمًا",
      Entitle1: "افتح حسابًا في غضون ثوانٍ.",
      footerPlatform: "المنصات",
      footerSupport: "الدعم",
      footerAccount: "أنواع الحسابات",
      footerForex: "تداول الفوركس",
      footerStock: "مشتقات الأسهم",
      footerCommaondities: "السلع",
      footerPrecious: "المعادن الثمينة",
      footerShares: "الأسهم",
      footerCrypto: "العملات المشفرة",
      blueBTN: "ابدأ التداول الآن",
      footerEquity: "مؤشرات الأسهم",
      footerEnergies: "الطاقات",
      footerTrading: "تداول النسخ من BBCorp",
      footerCompetitions: "مسابقات BBCorp",
      footerPolicy: "سياسة التنفيذ",
      footerLeverage: "الهامش والرافعة المالية",
      footerMt5: "منصات MT5",
      footerHelp: "المساعدة والدعم",
      footerContact: "اتصل بنا",
      footerPolicy: "اتصل بنا",
      footerTerm: "شروط BBCorp",
      footerButtontitle: "حمّله الآن",
      Discover: {
        title: "مصمم للنمو",
        subtitle: "اكتشف أسواقنا",
        description: "نحن نخدم العملاء المؤسساتيين والأفراد في تنفيذ التداولات",
        description1: "حول العالم — نوفر الدقة والسرعة والموثوقية",
        description2: "في أي وقت ومن أي مكان.",
      },
      footerButtonName: "جوجل بلاي",
      footerButton2title: "حمّل من or التنزيل من",
      footerButton2Name: "متجر التطبيقات ",
      footerPayment: "تم قبول الدفع ",
      footerLegal: "الوثائق القانونية",
      footerCopy: "حقوق النشر",
      footerRight: "شركة BBCorp المحدودة. جميع الحقوق محفوظة.",
      footerDescription:
        "عقود الفروقات (CFDs) هي أدوات مالية معقدة وتنطوي على مخاطر عالية لفقدان الأموال بسرعة بسبب الرافعة المالية. ٧٧٪ من حسابات المستثمرين الأفراد تخسر الأموال عند تداول عقود الفروقات مع هذا المزود. يجب أن تأخذ في الاعتبار ما إذا كنت تفهم كيفية عمل عقود الفروقات وما إذا كنت تستطيع تحمل المخاطرة العالية بفقدان أموالك. نوصي بالحصول على مشورة مهنية قبل الاستثمار. تُعد شركة BBcorp LTD (Comoros) Limited شركة مسجلة ذات مسؤولية محدودة بموجب قوانين اتحاد جزر القمر، تحت رقم التسجيل HV00724047، ويقع عنوانها المسجل في شارع بونوفو – فومبوني – جزيرة موهيلي – اتحاد جزر القمر. تم ترخيص شركة BBcorp LTD (Comoros) Limited من قبل هيئة الخدمات الدولية في موالي كمزود خدمة وساطة وتنفيذ مالي دولي بموجب رخصة رقم BFX2024241. كما يوجد لها مكتب فعلي في قبرص في العنوان التالي: 23A تاكي سوفوكليوس - 2049، ستروفولوس، نيقوسيا. نحن نقدم خدمات تنفيذ فقط، ولا نقدم استشارات أو خدمات إدارة استثمارية. أي تحليل أو رأي أو تعليق أو مواد بحثية منشورة على موقعنا الإلكتروني هي لأغراض معلوماتية وتعليمية فقط، ولا تُعتبر تحت أي ظرف من الظروف عرضًا أو توصية أو مشورة أو دعوة للبيع أو الشراء. نحن سعداء باستقبال طلبات فتح الحسابات من مجموعة واسعة من الدول، ومع أننا لا نستطيع حاليًا قبول الطلبات من بعض الدول، فإننا نشجعك على التقديم إذا كنت تستوفي معايير الأهلية، ونُعرب عن تقديرنا لاهتمامك بخدماتنا. قد تتم تنسيق عمليات الإيداع والسحب أو تسهيلها أو معالجتها من قبل شركة BBcorp LTD أو إحدى الشركات التابعة لها، بما في ذلك BBcorp LB.",
      weathTitle: "ابدأ ثروتك",
      weathTitles: "رحلتك معنا",
      weathSetUp: "الإعداد الفوري",
      weathSupport: "دعم 24/7",
      weathLiquidity: "اسيولة عالية",
      weathButton: "تواصل مع فريق المبيعات",
      sliderTitle: "تراخيص دولية. ثقة محلية.",
      sliderDescription:
        "في بي بي كورب، الامتثال ليس مجرد إجراء شكلي، بل هو أساس. نحن نعمل ضمن إطار متنامٍ من المعايير التنظيمية الدولية التي تضمن أن كل جانب من جوانب أعمالنا آمن وشفاف ومصمم للتوسع عالميًا. ومع توسعنا في أسواق جديدة، نظل ملتزمين بالحفاظ على أعلى مستويات الثقة والحوكمة والنزاهة التشغيلية.",
      sliderCard1: "أفضل وسيط",
      sliderCard2: "الشرق الأوسط",
      shareCom: "لماذا تتداول الأسهم",
      shareCom1: "مع BBCorp؟",
      shareComDes: "احصل على حصتك من أنجح الشركات في العالم",
      shareComDes1: "وقم بتوسيع إمكانياتك.",
      sliderCard3: "الأكثر موثوقية",
      sliderCard4: "آسيا",
      sliderCard5: "أفضل وسيط",
      sliderCard6: "أفريقيا",
      sliderCard7: "الأسرع نمواً",
      sliderCard8: "عالمي",
      globeHead: "معترف به دوليًا",
      globeTitle: "التنفيذ على الساحة العالمية",
      globeDesc:
        "نحن نخدم العملاء المؤسسيين والأفراد من خلال تنفيذ الصفقات في جميع أنحاء العالم — مقدمين الدقة، والسرعة، والموثوقية، في أي وقت ومن أي مكان.",
      globeNumber: "١٠٬٠٠٠+",
      globeNumbers: "١٠٠٠+",
      globeNumber2: "عملاء سعداء",
      globeNumber3: "٢٠٠٥",
      globeNumber4: "تأسست",
      globeNumber5: "المعاملاتة",
      globeNumber6: "٣",
      globeNumber7: "تراخيص منظمة",
      globeButton: "ابدأ التداول بأمان",
      investTitle: "من المستثمرين الشباب إلى المحركين المؤسسيين للأسواق.",
      investTitles: "نحن نقدم خدمات لجميع أنواع الحسابات.",
      stripeCardTitle: "فوركس ",
      stripeCoomDes:
        "من الذهب إلى القهوة — يمكنك الوصول إلى الأسواق الفعلية من خلال العقود الرقمية. تحوّط ضد التضخم أو تداول الزخم.",
      stripeCardDes:
        "تداول في أكبر سوق مالي في العالم مع فروقات أسعار ضيقة للغاية وتنفيذ فوري. العملات الرئيسية، الثانوية، والنادرة — على مدار الساعة طوال 5 أيام في الأسبوع، بدون توقف.",
      tradingStripe: "ابدأ التداول",
      srtripeThirdDes:
        "تقلبات رقمية، وفرص حقيقية. تداول أبرز العملات الرقمية باستخدام الرافعة المالية وبدقة في بيئة آمنة.",
      stripeFourDesc:
        "تتبع وتداول الأسواق بالكامل — مثل S&P وDAX وNASDAQ والمزيد — من حساب واحد وفي الوقت الفعلي.",
      stripeFifth:
        "النفط والغاز والطلب العالمي في حركة مستمرة. تداول في أسواق الطاقة بأسعار مرنة وهوامش واضحة.",
      stripeSixth: "ابنِ ثروتك مع أقوى الشركات في العالم — في كل مكان.",
      newWealthTitle: "لست مستعدًا لـ",
      newWealthTitle2: "الصفقة الحقيقية",
      newWealthDes:
        "ابدأ بالتجربة في بيئة تجريبية قبل أن تبدأ باستخدام حسابك الحقيقي.",
      newWealthDes2: "متى ما كنت مستعدًا لرحلتك نحو الثراء، نحن جاهزون لخدمتك.",
      legalTitle: "الوثائق القانونية",
      legalTitleDes:
        "من المهم أن تقرأ وتفهم أي مستندات تتعلق بالخدمات التي تهتم بها. سيتم تمييز أي شيء يتعلق بحسابك بوضوح أثناء عملية التسجيل. يجب أن تطّلع على هذه",
      legalTitleDes1: "المستندات قبل إكمال التسجيل الخاص بك.",
      legalButton: "افتح حسابًا الآن",
      lagalSemiTitle1: "بي بي كورب جلوبال ليمتد",
      lagalSemiTitle2: "شركة بي بي كورب (إس سي) المحدودة",
      legalSemiTitle3: "بي بي كورب (كوموروس) المحدودة",
      legalMainHead: "الشروط والسياسات التجارية (باللغة الإنجليزية)",
      leagcard1: "الشروط والأحكام",
      leagcard2: "الشروط والأحكام الخاصة بخدمة VPS",
      leagcard3: "مكافحة غسل الأموال",
      leagcard4: "سياسة تنفيذ الأوامر",
      leagcard5: "إفصاح المخاطر للأدوات المالية",
      leagcard6: "سياسة تضارب المصالح",
      leagcard7: "إجراءات معالجة الشكاوى",
    },
  };

  const toggleLanguage = (newLang) => {
    setLanguage(newLang);
  };

  return (
    <LanguageContext.Provider
      value={{ language, toggleLanguage, translations }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
